import '../scss/App.scoped.scss';
import { useState, useEffect } from "react";

function ScHeader({headerText, pText}) {

  return (
  <div className="para">
    <div className="inner">
      <h2>{headerText}</h2>
      <p>{pText}</p>
    </div>
  </div>
  );
}

export default ScHeader;